import api from '@/helpers/api'

const API_READ = `/api/theme-corporate/`;
const API_UPDATE = API_READ;
const API_CREATE = API_READ;
const API_DELETE = API_READ;

export default {
  namespaced: true,
  state: {
    status: '',
    themeCorporates: [],
    meta: {
      page: 1,
      limit: 10,
      total: 1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading';
    },
    read(state, { themeCorporates }) {
      state.themeCorporates = [...themeCorporates];
    },
    error(state) {
      state.status = 'error';
    },
    success(state) {
      state.status = 'success';
    },
    read_single_success(state, { themeCorporate }) {
      state.themeCorporate = themeCorporate;
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta };
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    setTheme(state, themeData) {
      state.theme = themeData; // Simpan tema di state
    },
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta } = state;
      const { filter } = state;
      const { search } = state;

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, filter, search })
          .then((result) => {
            commit('read', { themeCorporates: result.data.data });
            commit('success');
            commit('switch_page', { meta: { ...result.data.meta } });
            return resolve();
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },

    delete({ commit }, id) {
      commit('request');

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_DELETE}${id}`, {})
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            console.log(err.response.data);
            commit('error');
            return reject(err);
          });
      });
    },

    read_single({ commit }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}${id}`)
          .then((result) => {
            const responseData = result.data.data;

            const checkImage = (url) => {
              return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
              });
            };

            // Map: response key -> localStorage key
            const storageKeyMap = {
              'corporateLogo': 'corporateLogo',
              'backgroundImage': 'login_background',
              'favicon32': 'favicon32',
              'favicon16': 'favicon16',
              'page_title': 'page_title'
            };

            for (const [responseKey, storageKey] of Object.entries(storageKeyMap)) {
              if (!responseData[responseKey]) {
                localStorage.removeItem(storageKey);
                delete responseData[responseKey];
                continue;
              }

              if (Object.prototype.hasOwnProperty.call(responseData, responseKey)) {
                const isValid = checkImage(responseData[responseKey]);

                if (isValid) {
                  localStorage.setItem(storageKey, responseData[responseKey]);
                } else {
                  localStorage.removeItem(storageKey);
                }
                delete responseData[responseKey];
              }
            }
            commit('read_single_success', { themeCorporate: responseData });
            commit('success');
            return resolve(responseData);
          }).catch((err) => {
            commit('error');
            return reject(err.response.data);
          });
      });
    },

    update({ commit }, { data }) {
      // console.log('dataStore', data);

      commit('request');
      return new Promise((resolve, reject) => {
        api.request('put', `${API_UPDATE}${data.corporate_id}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },

    create({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('post', `${API_CREATE}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },
  },
  getters: {
    themeCorporates: (state) => state.themeCorporates,
  }
}